const ajax = require('sma.common/ajax');
const modals = require('sma.common/components/modals');

class SubmitConfirm extends modals.Modal {
	get cls() {
		return 'sma-modal sma-modal-confirm sma-modal-confirm-application sma-automation-popup-modal';
	}

	constructor(options) {
		super();

		const {
			appId,
		} = options;

		const title = options.title || gettext('Submit application');
		const description = options.description || gettext(
			'Please confirm submission of your application.<br><br>If you wish to take a look at the application before submitting, please <b>Review</b> it.',
		);
		const hideReviewButton = options.hideReviewButton || false;

		const url = reverse('application-save', { app_id: appId });
		const reviewUrl = reverse('application-submit-preview', { app_id: appId });

		const buttons = [
			{
				cls: 'float-left btn-secondary',
				id: 'sma-btn-modal-no',
				label: gettext('Cancel'),
				handler: () => {
					this.hide();

					setTimeout(() => {
						this.destroy();
					}, 1000);
				},
			}, hideReviewButton ? null : {
				cls: 'btn-secondary',
				id: 'sma-btn-modal-other',
				label: gettext('Review'),
				handler: () => {
					window.location.href = reviewUrl;
				},
			}, {
				cls: 'btn-primary',
				id: 'sma-btn-modal-yes',
				label: gettext('Submit'),
				handler: () => {
					ajax.post({
						url,
						alertOnSuccess: false,
						alwaysCallback: true,
						callback: (response) => {
							if (response.success) {
								window.location.href = reverse('application-completion-message', {
									app_id: response.app_id,
									round_id: response.round_id,
								});
							} else {
								this.hide();
								if (this.useButtonLoaders) {
									this.buttons.map(button => button.hideLoader());
								}
								setTimeout(() => {
									this.destroy();
								}, 1000);
							}
						},
					});
				},
			},
		].filter(btn => btn !== null);

		this.handleOptions({
			title,
			destroyOnClose: true,
			buttons,
			useButtonLoaders: true,
		});

		this.element = $('<div class="sma-modal-desc"></div>')
			.html(description);

		this.setElement(this.element[0]);

		this.render();
		this.show();
	}
}

module.exports = SubmitConfirm;



// WEBPACK FOOTER //
// ../apps/chide/products/smapply/static/sma.applicant/confirm_submit_modal.js